import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import "../style/services-usa/shopify-web-development/_provenTechniques.scss";

function ProvenTechniques() {
  return (
    <section
      className="redefinepatient_services tekgrip_section proven-techniques p-100 overflow-x-hidden"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={6} xxl={6}>
            <h2>Our Approach to Solving Challenges</h2>
          </Col>
          <Col xs={12} md={5} lg={5} xl={6} xxl={6}>
            <p>
              TekRevol team uses smart strategies in handling challenges and
              breakthrough technologies are implemented to solve unique needs or
              problems. 
            </p>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={12} lg={12} xl={6} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            <span>01.</span> Complex ERP Integration
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            <span>02.</span> Overly Complex and Inefficient
                            Solutions
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            <span>03.</span> Buyer-Vendor Communication Gaps
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={12} lg={12} xl={6} className="p-0">
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <div className="content-wrap">
                          <div className="content">
                            <h3>Complex ERP Integration</h3>
                            {/* <p className="small-heading">
                              Streamline User Journeys
                            </p> */}
                            <p>
                              Integration of the portal with an ERP system takes
                              time and may be complex. However, for the next
                              level of fully automated business processes in
                              which manual interaction is maintained and all
                              business-critical information is tracked, your B2B
                              Vendor portal must be deeply integrated with ERP.
                              We guarantee a flawless transfer, ensuring that
                              your organization gets the most out of its new
                              solution.
                            </p>
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/vendor-portal/complex-erp.webp"
                              alt="complex erp"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={280}
                              height={365}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <div className="content-wrap">
                          <div className="content">
                            <h3>Overly Complex and Inefficient Solutions</h3>
                            {/* <p className="small-heading">
                              Invest in Custom Design and High-Quality Imagery
                            </p> */}
                            <p>
                              We tailor our strategy to your business exactly,
                              eliminating needless complexity, to meet the
                              various needs of various vendors. We provide
                              flexible vendor account choices, allowing for deep
                              connection with the internal systems of major
                              suppliers and restricted capability for smaller
                              vendors.
                            </p>
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/vendor-portal/overly-complex.webp"
                              alt="overly complex"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={280}
                              height={364}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <div className="content-wrap">
                          <div className="content">
                            <h3>Buyer-Vendor Communication Gaps</h3>
                            {/* <p className="small-heading">
                              Focus on Client-Centric Language
                            </p> */}
                            <p>
                              Lack of effective interaction can lead to a
                              variety of issues, including failed delivery
                              notices. To avoid such problems, we improve and
                              implement features such as alerts, notifications,
                              and a real-time dashboard that keeps you up to
                              date at all times and prevents you from missing
                              any critical information.
                            </p>
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/vendor-portal/buyer-vendor.webp"
                              alt="buyer vendor"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={280}
                              height={364}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ProvenTechniques;
